import { render, staticRenderFns } from "./product.vue?vue&type=template&id=097b9474&scoped=true&"
import script from "./product.vue?vue&type=script&lang=ts&"
export * from "./product.vue?vue&type=script&lang=ts&"
import style0 from "./product.vue?vue&type=style&index=0&id=097b9474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b9474",
  null
  
)

export default component.exports